import { NgModule } from '@angular/core';
import { InputBaseModule } from './input-base/input-base.module';
import { ProductItemBaseModule } from './product-item-base/product-item-base.module';

/**
 * Angular module providing base component classes for form inputs and product items.
 *
 * @remarks
 * This module exports {@link InputBaseModule} and {@link ProductItemBaseModule}, which contain
 * base component classes that provide common functionality for input components and product
 * item components throughout the design system.
 *
 * @example
 *
 * ```typescript
 * import { BaseClassesModule } from '@backbase/ui-ang/base-classes';
 *
 * @NgModule({
 *   imports: [NgbTimepickerModule, FormsModule, ReactiveFormsModule, BaseClassesModule],
 *   declarations: [InputTimepickerComponent],
 *   exports: [InputTimepickerComponent],
 * })
 * export class InputTimepickerModule {}
 * ```
 */
@NgModule({
  imports: [InputBaseModule, ProductItemBaseModule],
  exports: [InputBaseModule, ProductItemBaseModule],
})
export class BaseClassesModule {}
